import { type MaybeRefOrGetter } from 'vue'

import { useLibraryQueryStore } from '../stores/library.query-store'

export const useLibrary = (locationId: MaybeRefOrGetter<string>) => {
  const queryStore = useLibraryQueryStore(locationId)

  const fetchAllProducts = queryStore.fetchAllProductsQuery

  const fetchUpsellProducts = queryStore.fetchUpsellProductsQuery

  /** Client Portal Discover feed (bundles + single courses). See `fetchDiscoverProductsQuery`. */
  const fetchDiscoverProducts = queryStore.fetchDiscoverProductsQuery

  /** Post counts for My Courses tabs. The library list does not include them. */
  const fetchLibraryProgress = queryStore.fetchLibraryProgressQuery

  return {
    fetchAllProducts,
    fetchUpsellProducts,
    fetchDiscoverProducts,
    fetchLibraryProgress,
  }
}
